import { SignUpForm as SignUpFormLayout } from './blocks/00-form';
import { StepTypeAndEmail } from './blocks/01-type-and-email';
import { StepOwnerConfirm } from './blocks/02-owner-confirm';
import { StepOwnerDetails } from './blocks/02-owner-details';
import { StepOwnerType } from './blocks/02-owner-type';
import { StepBusinessStructure } from './blocks/03-business-structure';
import { StepBusinessABN } from './blocks/03a-abn';
import { StepBusinessDetails } from './blocks/04-business-details';
import { StepBusinessCompanyDetails } from './blocks/05-business-company-details';
import { StepTrusteeDetails } from './blocks/06-trustee-details';
import { StepTrusteeCompanyDetails } from './blocks/07-trustee-company-details';
import { StepUserDetails } from './blocks/08-user-details';
import { StepOneTimeCode } from './blocks/09-one-time-code';
import { StepChangeEmail } from './blocks/10-change-email';
import { StepCreateContract } from './blocks/11-create-contract';
import { StepCompleteContract } from './blocks/12-complete-contract';
import { StepReviewContract } from './blocks/13-review-contract';
import { StepOwnerInviteBuilder } from './blocks/16-owner-invite-builder';
import { StepEmployeeInviteDirector } from './blocks/17-employee-invite-director';
import { StepEmployeeInvitePartner } from './blocks/18-employee-invite-partner';
import { StepEmployeeInviteSoleTrader } from './blocks/19-employee-invite-sole-trader';
import { StepEmployeeInviteTrustee } from './blocks/20-employee-invite-trustee';
import { StepSignContract } from './blocks/21-sign-contract';

export const SignUpForm = () => {
  return (
    <SignUpFormLayout>
      <StepTypeAndEmail />
      <StepOwnerType />
      <StepOwnerDetails />
      <StepOwnerConfirm />
      <StepBusinessDetails />
      <StepBusinessStructure />
      <StepBusinessABN />
      <StepBusinessCompanyDetails />
      <StepTrusteeDetails />
      <StepTrusteeCompanyDetails />
      <StepUserDetails />
      <StepOneTimeCode />
      <StepChangeEmail />

      <StepCreateContract />
      <StepCompleteContract />
      <StepReviewContract />
      <StepSignContract />

      <StepOwnerInviteBuilder />
      <StepEmployeeInviteDirector />
      <StepEmployeeInvitePartner />
      <StepEmployeeInviteSoleTrader />
      <StepEmployeeInviteTrustee />
    </SignUpFormLayout>
  );
};
